<template>
  <v-footer :padless="true" class="footer mt-2">
    <v-card flat tile width="100%">
      <v-card-text class="text-center">
        <v-btn text href="https://auditedmedia.com/privacy-policy"
          >Privacy Policy</v-btn
        >
        <v-btn text href="https://auditedmedia.com/terms-use"
          >Terms of Use</v-btn
        >
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text footer text-center">
        &copy;{{ new Date().getFullYear() }} Alliance for Audited Media. All
        Rights Reserved.
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
.footer {
  background-color: #1a70c5;
}
</style>
